import React from "react";
import { MdCampaign, MdHelp, MdEmojiEvents, MdForum } from "react-icons/md";
import { PostType } from "../../types/community";

interface PostTypeBadgeProps {
  type: PostType;
  size?: "sm" | "md" | "lg";
}

const PostTypeBadge: React.FC<PostTypeBadgeProps> = ({ type, size = "md" }) => {
  const getTypeConfig = (postType: PostType) => {
    switch (postType) {
      case "announcement":
        return {
          label: "Announcement",
          icon: MdCampaign,
          bgColor: "bg-purple-100 dark:bg-purple-900/30",
          textColor: "text-purple-700 dark:text-purple-300",
          iconColor: "text-purple-600 dark:text-purple-400",
          borderColor: "border-purple-200 dark:border-purple-700",
        };
      case "support":
        return {
          label: "Support",
          icon: MdHelp,
          bgColor: "bg-blue-100 dark:bg-blue-900/30",
          textColor: "text-blue-700 dark:text-blue-300",
          iconColor: "text-blue-600 dark:text-blue-400",
          borderColor: "border-blue-200 dark:border-blue-700",
        };
      case "challenge":
        return {
          label: "Challenge",
          icon: MdEmojiEvents,
          bgColor: "bg-orange-100 dark:bg-orange-900/30",
          textColor: "text-orange-700 dark:text-orange-300",
          iconColor: "text-orange-600 dark:text-orange-400",
          borderColor: "border-orange-200 dark:border-orange-700",
        };
      case "general":
      default:
        return {
          label: "General",
          icon: MdForum,
          bgColor: "bg-gray-100 dark:bg-gray-700/30",
          textColor: "text-gray-700 dark:text-gray-300",
          iconColor: "text-gray-600 dark:text-gray-400",
          borderColor: "border-gray-200 dark:border-gray-600",
        };
    }
  };

  const getSizeClasses = () => {
    switch (size) {
      case "sm":
        return {
          container: "px-2 py-0.5 text-xs",
          icon: "h-3 w-3",
        };
      case "lg":
        return {
          container: "px-4 py-2 text-base",
          icon: "h-5 w-5",
        };
      case "md":
      default:
        return {
          container: "px-3 py-1 text-sm",
          icon: "h-4 w-4",
        };
    }
  };

  const config = getTypeConfig(type);
  const sizeClasses = getSizeClasses();
  const Icon = config.icon;

  return (
    <span
      className={`inline-flex max-w-fit items-center space-x-1.5 rounded-full border font-medium ${config.bgColor} ${config.textColor} ${config.borderColor} ${sizeClasses.container}`}
    >
      <Icon className={`${config.iconColor} ${sizeClasses.icon}`} />
      <span>{config.label}</span>
    </span>
  );
};

export default PostTypeBadge;
